var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallCenterListIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 42,
    viewBox: "0 0 31 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 0.5H3.875C1.73568 0.5 0 2.22168 0 4.34375V37.6562C0 39.7783 1.73568 41.5 3.875 41.5H27.125C29.2643 41.5 31 39.7783 31 37.6562V4.34375C31 2.22168 29.2643 0.5 27.125 0.5ZM11.625 3.0625H19.375C20.0854 3.0625 20.6667 3.63906 20.6667 4.34375C20.6667 5.04844 20.0854 5.625 19.375 5.625H11.625C10.9146 5.625 10.3333 5.04844 10.3333 4.34375C10.3333 3.63906 10.9146 3.0625 11.625 3.0625ZM15.5 13.3125C18.3497 13.3125 20.6667 15.6107 20.6667 18.4375C20.6667 21.2643 18.3497 23.5625 15.5 23.5625C12.6503 23.5625 10.3333 21.2643 10.3333 18.4375C10.3333 15.6107 12.6503 13.3125 15.5 13.3125ZM24.5417 32.275C24.5417 33.1238 23.7344 33.8125 22.7333 33.8125H8.26667C7.26563 33.8125 6.45833 33.1238 6.45833 32.275V30.7375C6.45833 28.191 8.88828 26.125 11.8833 26.125H12.287C13.2799 26.5334 14.3617 26.7656 15.5 26.7656C16.6383 26.7656 17.7281 26.5334 18.713 26.125H19.1167C22.1117 26.125 24.5417 28.191 24.5417 30.7375V32.275Z",
    fill: "#E7E7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenterListIcon1);
export default __webpack_public_path__ + "static/media/call-center-list-icon-1.c86ac36f97e4684ccc604e46db128dec.svg";
export { ForwardRef as ReactComponent };